module.exports = __webpack_public_path__ + "static/media/camera.618e81fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/ServiceIcons/camera.svg
// module id = 1209
// module chunks = 0